import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { takeWhile } from 'rxjs';
import { AppConfig } from 'src/environments/app-config.interface';
import { Config } from 'src/app/services/auth/Config';
import { AppConfigService } from 'src/environments/app-config.service';
import {
  clearOAuthPkceData,
  resetOAuthAttemptCount,
  saveCodeVerifier,
} from 'src/app/services/auth/pkce-storage.util';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class TokenValidationService {

  private environment: any;
  private apiUrl: string = '';
  private config: Config;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigService,
  ) {
    this.getApiConfig();
    this.config = new Config();
  }

  validateToken(token: any) {
    const body = {
      data: {
        jweText: token,
      },
    };
    // return this.httpClient.post<TokenCarbon>(this.apiUrl, body);
    return this.mockTest();
  }

  mockTest(): any {
    const body = {
      data: {
        id: 2,
        nome: 'CA-Acesso Geral NoMe',
        nomeSimplificado: 'ACESSO_GERAL',
        descricao: 'Função Exclusiva CETIP que quando atribuida a um usuário atribui a este a prerrogativa de lançamentos para qualquer participante além de lançamentos para a própria CETIP',
        estaBloqueada: false,
        links: [
          {
            rel: 'self',
            href: 'http://balcao-ms-dev.internalenv.corp/controleacesso/api/v1/funcoes/2',
          },
        ],
      },
    };
    return body;
  }

  pingRedirect(): void {
    window.location.replace(this.buildAuthorizationUrl());
  }

  public logout(): void {
    this.logoutAndRedirectToLogin();
  }

  public logoutAndRedirectToLogin(): void {
    clearOAuthPkceData();
    resetOAuthAttemptCount();
    sessionStorage.clear();
    document.cookie = 'session=; Max-Age=0; path=/';
    this.redirectTo(this.buildLogoutRedirectUrl());
  }

  public buildLogoutRedirectUrl(): string {
    const loginUrl = this.buildAuthorizationUrl();
    return `${this.environment.url_base}/idp/startSLO.ping?TargetResource=${encodeURIComponent(loginUrl)}`;
  }

  private redirectTo(url: string): void {
    window.location.href = url;
  }

  private buildAuthorizationUrl(): string {
    const randomBytes = CryptoJS.lib.WordArray.random(32);
    const codeVerifier = CryptoJS.enc.Hex.stringify(randomBytes);
    const codeChallenge = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);
    const codeChallengeEncoded = codeChallenge.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    saveCodeVerifier(codeVerifier);

    return `${this.environment.url_base}/as/authorization.oauth2?client_id=${this.environment.client_id}&response_type=${this.environment.response_type}&redirect_uri=${this.environment.redirect_url}&code_challenge=${codeChallengeEncoded}&code_challenge_method=${this.environment.code_challenge_method}`;
  }

  private getApiConfig(): void {
    this.appConfig.$appConfig
      .pipe(
        takeWhile((response) => response !== ({} as AppConfig)),
      )
      .subscribe(() => {
        this.environment = this.appConfig.config;
        this.apiUrl = this.environment.apiToken;
      });
  }
}
